@if (!checkRoute()) {
  <div class="header-mobile-wrapper" [ngClass]="{'header-mobile-wrapper-light': grupoWhiteMode,'header-mobile-wrapper-cool' : grupoCoolMode}">
    <div class="d-flexbox">
      @if (mode=='Ajustes') {
        <div class="btn-accion" (click)="navigate()" >
          <img src="/assets/images/icons/header/Settings.svg" alt="img"/>
        </div>
      }
      @if (mode=='BackArrow') {
        <div class="btn-accion" (click)="back()" >
          <img src="/assets/images/icons/header/arrow-left.svg" alt="img"/>
        </div>
      }
      <div class="title">
        <h4>{{title}}</h4>
      </div>
    </div>
    @if (showBtnRight) {
      <div class="scan-container" (click)="navRightIconClick()">
        <img class="scan-icon" src="{{iconRightButton}}" alt="img">
      </div>
    }
  </div>
} @else {
  <!--DETAIL PLAYS-->
}

